module.exports = __webpack_public_path__ + "static/img/12.1717672.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/12.png
// module id = QdSE
// module chunks = 0